import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { EntityService } from "../../services/entity-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { RightService } from "../../services/rights-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AclService } from "../../services/acl-service";
import { VariesByCatalogService } from "../../services/varies-by-catalog-service";

export class AssetRightsController {
	static $inject = ["$scope", "$q", "$window", "$timeout", "entityService", "entityConfigService",
		"rightService", "notifyService", "eventService", "aclService", "variesByCatalogService"];

	initialized: boolean;
	entityID: string;
	entity: Models.IEntity;
	rightSets: Models.IPropertyRightsetDocumentRelationshipPair[];
	availableRights: Models.IPropertyAvailability2[];
	test: number[];
	visibility: number;
	templates: Models.ICharacteristicTemplate[];
	modalTitle: string;
	createModalOpen: boolean;
	newCharDataCollection: Models.ICharDataCollection;
	canEdit: boolean;
	canCreateRights: boolean;
    
	forceRefresh: boolean;

	variesByCatalogOpenModal: boolean;
	hasVariesByCatalog: boolean;
	variesByCatalogParentTemplateID: string;
	variesByCatalogCharDataCollection: Models.ICharDataCollection;
	variesByCatalogSelectedAssets: { [key: number]: string };
	newRightsIDs: string[];
	locked: boolean;
	canCopy: boolean;

	rightsDataDefaults: Models.IDataDefaultSet[];
    newDataDefaultSetEntityIDs: string[];

	showFilter: boolean;
	relationshipRequired: boolean;
	selectedEntities: Models.IEntitySearchDoc[];	
	templateColors: { [key: number]: string } = {};

	constructor(
		private $scope: ng.IScope,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private $timeout: ng.ITimeoutService,

        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
		private rightService: RightService,
		private notifyService: NotifyService,
		private eventService: EventService,
		private aclService: AclService,
		private variesByCatalogService: VariesByCatalogService) {

		this.initialized = false;
		this.entityID = "";
		this.entity = null;
		this.rightSets = [];
		this.availableRights = [];
		this.visibility = 1;
		this.templates = [];
		this.test = [];
		this.modalTitle = "";
		this.createModalOpen = false;
		this.newCharDataCollection = null;
		this.canEdit = false;
		this.canCreateRights = false;

		this.variesByCatalogOpenModal = false;
		this.hasVariesByCatalog = false;
		this.variesByCatalogSelectedAssets = {};
		this.locked = false;
		this.canCopy = false;

		this.showFilter = true;

		$scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => [this.entityID, this.entity], (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.variesByCatalogSelectedAssets = {};
				this.variesByCatalogSelectedAssets[this.entityID] = this.entity.title;
			}
		}, true);

		$scope.$watch(() => {
			if (this.entityID == null) {
				return null;
			} else {
				return this.entityID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						this.RefreshParent();
					});
				}
			});
	}

	Init(entityID: string) {
		this.entityID = entityID;
		this.notifyService.startProgress();

		var promise2 = this.GetEntity()
			.then((result) => {
				this.entityService.getAssociatedTemplatesDefaults(result.record.charTypeID, result.record.templateID, Consts.CharTypeIDs.right)
					.then((res) => {
						this.rightsDataDefaults = res.dataDefaultSets;
					});

				this.entity = result.record;
				if (result.charDataCollection.status.lockIndicator > 0) {
					this.locked = true;
				}
				else {
					this.locked = false;
				}
				return this.GetRightTemplates();
			}).then((result) => {
				this.templates = _(result)
					.filter((template) => Utils.AclUtil.hasCreateAccess(this.aclService.acls, template.acl))
					.sortBy((template) => { return template.sequenceNumber; })
					.valueOf();										
			});

		var promise3 = this.aclService.loadAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod1.Rights);
				this.canCreateRights = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod1.Rights);
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod1);
			});

		var promise4 = this.entityConfigService.getCharacteristicTemplates(Consts.CharTypeIDs.right)
			.then((result) => {
				this.templateColors = result.reduce(function (map, obj) {
					map[obj.templateID] = obj.visualization;
					return map;
				}, {});	
			});

		this.$q.all([promise2, promise3, promise4])
			.then(() => {
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Cancel(rightSet) {
		this.notifyService.startProgress();
		this.GetCharDataCollection(rightSet.record.id)
			.then((result) => {
				rightSet.charDataCollection = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(rightSet, isValid) {
		if (isValid) {
			var entityID = rightSet.record.id;
			var charDatas = rightSet.charDataCollection.charDatas;
			this.notifyService.startProgress();
			this.entityService.saveCharData(entityID, charDatas)
				.then(() => {
					this.forceRefresh = true;
				}, this.notifyService.errorResponseHandler)
				.then(() => {
					this.notifyService.notifySuccess("RightSet Saved");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	CreateOpen(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
		$event.preventDefault();

		this.notifyService.startProgress();

		var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
		var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.right, template.templateID);

        this.relationshipRequired = false;
        this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(Consts.CharTypeIDs.right, template.templateID, Consts.CharTypeIDs.user)
            .then((res) => {
                if (res && res.charTypeID) {
                    this.relationshipRequired = true;
                }
            });

		this.entityService.getEmptyEntityCharData(templateID)
			.then((result) => {
				this.newCharDataCollection = result;
				this.variesByCatalogService.clearSavedFields();
				this.selectedEntities = [];
				this.createModalOpen = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreateSave(isValid: boolean) {
		if (isValid) {

			var charDataCollection = this.newCharDataCollection;
			var charDatas = charDataCollection.charDatas;
			var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
			var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.right, charDataCollection.templateMetaData.templateID);
			var parentEntityID = this.entityID;
			var childCharTypeIDs: number[] = [Consts.CharTypeIDs.user];
			var childEntityIDs: string[] = this.selectedEntities.map(s => s.entityID);

			this.notifyService.startProgress();
			this.entityService.createEntityWithOptions(templateID, parentEntityID, charDatas, childCharTypeIDs, childEntityIDs)
				.then(() => {
					this.forceRefresh = true;
				})
				.then(() => {
					this.notifyService.notifySuccess("Rights Created");
					this.createModalOpen = false;
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	/*
	 * Used with the Varies by Catalog option.  Creates multiple RightSets (one per Catalog item)
	 * using a modal to allow for "bulk" entry
	 */
	QuickRightsEntry(charDataCollection: Models.ICharDataCollection, isValid: boolean) {
		if (isValid) {
			this.createModalOpen = false;
			this.variesByCatalogParentTemplateID = Utils.IdBuilder.buildTemplateID(charDataCollection.templateMetaData.divID, charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.templateID);
			this.variesByCatalogCharDataCollection = _.cloneDeep(charDataCollection);			
			this.variesByCatalogOpenModal = true;
		}
	}

	CancelModal() {
		this.createModalOpen = false;
		this.variesByCatalogService.clearSavedFields();
	}

	GetAvailableRights(entityID: string) {
		this.entityID = entityID;
		this.notifyService.startProgress();

		return this.rightService.getAssetAvailableRights(this.entityID)
			.then((result) => {
				this.availableRights = result;
			}).finally(() => {
				this.initialized = true;
				this.notifyService.endProgress();
			});
	}

	GetCharDataCollection(entityID: string) {
		return this.entityService.getEntityCharData(entityID);
	}

	GetEntity() {
		return this.entityService.getEntity(this.entityID);
	}

	GetRightTemplates() {
		var templateID = this.entity.templateID;
		return this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.property, templateID, Consts.CharTypeIDs.right);
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Catalog Item?") && this.$window.confirm("Are you REALLY SURE you want to delete this Catalog Item?")) {
			this.notifyService.startProgress();
			this.entityService.deleteEntity(this.entityID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.PropertyListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Catalog Item");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	RefreshParent() {
		this.GetEntity()
			.then((result) => {
				this.entity = result.record;
				if (result.charDataCollection.status.lockIndicator > 0) {
					this.locked = true;
				}
				else {
					this.locked = false;
				}
			});
	}

	RefreshAll(): ng.IPromise<any> {
		return this.RefreshValidation();
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	CopyDataDefaultSet(setID: string, entityID: any) {
		var id: number = -1;
		var charTypeID: number = -1;
		if (parseInt(entityID)) {
			id = entityID;
		} else {
			id = Utils.IdBuilder.splitEntityID(entityID).recID;
			charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
		}
		this.notifyService.startProgress();

		this.entityService.copyDataDefaultSet(setID, charTypeID, id, true)
			.then((result) => {
				this.newDataDefaultSetEntityIDs = [];
				if (result.success) {
					_.forEach(result.data, (r: string) => {
						this.newDataDefaultSetEntityIDs.push(r);
					});
				}

				this.$timeout(() => {
					this.forceRefresh = true;
				}, 500);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	DeleteDataDefaultSet(setID: string) {
		this.notifyService.startProgress();

		this.entityService.deleteDataDefaultSet(setID)
			.then((res) => {
				var index = -1;
				for (var i = 0; i < this.rightsDataDefaults.length; i++) {
					if (this.rightsDataDefaults[i].id == setID) {
						index = i;
						break;
					}
				}

				if (index > -1) {
					this.rightsDataDefaults.splice(index, 1);
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}
